/** Home card art: a sandbox with a cone of sand under a falling stream, and a dug hole beside it. */
export function SandCardArt() {
  const grains = Array.from({ length: 70 }, (_, i) => {
    const x = 30 + ((i * 97) % 260)
    const y = 128 + ((i * 53) % 52)
    return <circle key={i} cx={x} cy={y} r={1.1} fill="#a88a55" opacity={0.35} />
  })
  return (
    <svg viewBox="0 0 320 200" className="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice">
      <rect width="320" height="200" fill="#cfe9f2" />
      <rect x="14" y="118" width="292" height="72" rx="6" fill="#9b6b43" />
      <rect x="22" y="124" width="276" height="60" rx="4" fill="#e8d4a3" />
      {grains}
      {/* a cone with a trickle onto its tip */}
      <path d="M92 150 L 136 104 L 180 150 Z" fill="#d8963a" />
      <path d="M136 104 L 180 150 L 158 150 Z" fill="#b97f2e" />
      <path d="M118 150 L 136 132 L 150 150 Z" fill="#c2603c" opacity="0.85" />
      {[40, 52, 64, 76, 88, 98].map((y, i) => <circle key={y} cx={136 + (i % 2 ? 1.5 : -1.5)} cy={y} r="3" fill="#d8963a" />)}
      {/* a hole with sloped walls */}
      <ellipse cx="240" cy="152" rx="34" ry="12" fill="#c7ad78" />
      <ellipse cx="240" cy="155" rx="20" ry="6" fill="#a88a55" />
    </svg>
  )
}
